<div class="row justify-content-center">
  <div class="col-12">
    <h3 class="titel">{{ 'Who is having a birthday?' | translate }}</h3>
    <p class="titel">{{ 'Please fill out all mandatory fields (*). Your details will be needed for the further processing of the booking, as the reservation is made in the name of the guest of honor.' | translate }}</p>
  </div>
</div>
<app-partner-form [partner]='child' [isChild]="true" (eventFormInvalid)="partnerFormInvalid($event)" (eventFormValid)="partnerFormValid($event)"></app-partner-form>
